module.exports = __webpack_public_path__ + "img/analytic_warn.4de77c79.svg";